angular.module 'zc.core'

.factory 'Facade', ($filter, $httpOnce, Devise, Project) ->

  service =
    _forPath: (endpoint) ->
      "#{ZC_CONFIG.FACADE_API_URL}:#{ZC_CONFIG.FACADE_API_PORT}/api/v1#{endpoint}"

    request: (path, opts = {}) ->
      Devise.getCurrentUser().then () ->
        reqParams = _.assignIn {}, {
          method: 'GET'
          url: service._forPath(path)
          cache: true
          withCredentials: false
          headers:
            'X-LOGIN-TOKEN': Devise?.currentUser?.login_token
        }, opts

        if reqParams?.params?.json
          reqParams.params.json = service.transformDatesInRequest(reqParams.params.json)

        $httpOnce(reqParams)

    transformDatesInRequest: (obj) ->
      json = _.assignIn {}, obj

      for key, value of obj
        continue if !key || !key.endsWith('_at')

        isUnixTimestampIsh = _.isNumber(value) && new Date(value).toString() != 'Invalid Date'
        if _.isDate(value) || isUnixTimestampIsh
          region = Project.getRegion()
          region ||= 'Asia/Tokyo' # default to server timezone when we use facade but are not in projects pages
          json[key] = $filter('changeDatetimeFrom')('localToRegion', value, 'integer', region)

      return json

    setLoginToken: (login_token) ->
      service.login_token = login_token

  service



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/facade_service.js.coffee